"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateUtil = void 0;
/* eslint-disable no-restricted-globals */
const moment_1 = __importDefault(require("moment"));
class DateUtil {
    static isNumber(value) {
        return !Number.isNaN(Number(value));
    }
    static isEmpty(date) {
        return !date || date === '';
    }
    static isValidTimeObj(time) {
        return (time &&
            DateUtil.isNumber(time.hour) &&
            time.hour >= 0 &&
            time.hour <= 23 &&
            DateUtil.isNumber(time.minute) &&
            time.minute >= 0 &&
            time.minute <= 59);
    }
    static convertTimeToUTCString(time) {
        if (DateUtil.isEmpty(time)) {
            return null;
        }
        // we're storing time in date object against a fixed date (2000-01-01)
        // we were using unix epoch (moment(0)), but it's not converted consistently across devices/browsers
        // due to different JS engines calculating daylight savings differently
        const date = (0, moment_1.default)('2000-01-01T00:00Z');
        // set time
        if (DateUtil.isValidTimeObj(time)) {
            date.hour(time.hour);
            date.minutes(time.minute);
        }
        // return this time as UTC
        return date.toISOString();
    }
}
exports.DateUtil = DateUtil;
